import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
export namespace TemporaryCloseGuard {
  export const canActivate: CanActivateFn = () => {
    const router = inject(Router);

    router.navigate(['/']);
    return false
  };

  export const canActivateChild: CanActivateChildFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) => canActivate(route, state);
}
